var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("HelppageController", [
    "$scope", "$location", "helpPageService",
    function ($scope, $location, helpPageService) {
        
        // #region variables
        $scope.list = [];
        //#endregion
        
        // #region Get Page Data 
        $scope.checkDataType = function (content) {
            return typeof content;
        };
        $scope.getHelpPageContent = function () {
            helpPageService.getHelpPageContent().then(function (response) {
                if (response && response.data) {
                    $scope.helpPage = response.data;
                    if (response.data != null && response.data != undefined) {
                        var machinesData = response.data.filter(function(info){
                            return (info.section && info.section.toLowerCase() == 'machines')
                        });
                        if(angular.isDefined(machinesData)&& machinesData.length >0 && angular.isDefined(machinesData[0].content) && machinesData[0].content.length >0)
                        {
                            $scope.helpPageTableContent = machinesData[0].content;
                        }
                    }
                }
            });
        };
        $scope.getHelpPageContent();
        //#endregion

        // #region Scroll to
        $scope.onScrollTo = function(){
            var params = $location.search();
            if(angular.isDefined(params) && angular.isDefined(params.topic)){
                var elem = document.getElementById("topic_" + params.topic);
                if (elem != null) {
                    elem.scrollIntoView({ behavior: 'smooth' });
                }
            }
        }
        angular.element(document).ready(function () {
            $scope.onScrollTo();
        });
        // #endregion
    }
]);
